// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    BUSINESSES: {
      ACTIVITYLOG: 'Activity Log',
      EXTENDPLAN: 'Extend Plan',
      INVOICE: 'Invoice',
      USERS: 'Users',
      GENERAL: 'General',
      BILLING: 'Billing',
      PLAN: 'Plan'
    },
    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
    },
    COMMON: {
      NO_DATA_AVAILABLE: 'No Data Available',
    },
    DAYS: {
      MONDAY: 'Monday',
      TUESDAY: 'Tuesday',
      WEDNESDAY: 'Wednesday',
      THRUSDAY: 'Thursday',
      FRIDAY: 'Friday',
      SATURDAY: 'Saturday',
      SUNDAY: 'Sunday',
    },
    BUSINESS_SETTING: {
      BRANDING: 'Branding',
      BUSINESS_DETAIL: 'Busines Detail',
      REWARD: 'Reward',
      PLAN: 'Plan',
      PLAN_NAME: 'Plan Name',
      PLAN_INFO: 'Plan Info',
    },
    CLIENT: {
      CLIENT: 'Client',
      CONTACT: 'Contact',
      SETTING: 'Setting',
      LOGIN: 'Login',
      ADDRESS: 'Address',
      REWARD: 'Reward',
      ARCHIVE: 'Archive',
    },
    LOCATION: {
      GENERAL: 'General',
      SCHEDULING: 'Scheduling',
      TIMESHEET: 'TimeSheet',
      LOOP: 'Loop',
    },
    UNAVAILABILITY: {
      EVERY_WEEK: 'Every Week',
      EVERY_TWO_WEEK: 'Every 2 Week',
      EVERY_FOUR_WEEK: 'Every 4 Week',
      EVERY_MONTH: 'Every Month',
      FROM: 'From',
      UNTIL: 'Until',
    },
    CLIENT_LOCATION: {
      LOCATION: 'Location',
      AREA: 'Area',
      CLIENT: 'Client',
      REVIEW_AND_SUBMIT: 'Review And Submit',
      LOCATION_NAME: 'Location Name',
      CLIENT_INFO: 'Client Info',
      CLIENT_NAME: 'Client Name',
      CONTACT_PERSON_FIRST_NAME: 'Contact Person First Name',
      CONTACT_PERSON_LAST_NAME: 'Contact Person Last Name',
      CONTACT_PERSON_MOBILE_NUMBER: 'Contact Person Mobile Number',
      CONTACT_PERSON_EMAIL: 'Contact Person Email Address',
      WEEK_START: 'Week starts with',
      ENABLE_LOGIN: 'Enable Login',
      LOCATION_DETAIL: 'Location Details',
      ADDRESS: 'Address',
      POINTS: 'Area',
      POINT_NAME: 'Area Name',
    },
    EMPLOYEE: {
      PERSONAL_DETAILS: 'Personal Detail',
      ADDRESS: 'Address',
      CONTACTS: 'Contact',
      PAY_RATES: 'Pay Rate',
      PROFESSIONAL_DETAIL: 'Professional Detail',
      JOB_INFORMATION: 'Job Information',
      BANK_DETAIL: 'Banking Detail',
      ASSIGN_LOCATION: 'Assign Location',
      UNAVAILABILITY: 'Unavailability',
      LEAVE: 'Leave',
      TRAINING_LICENCE: 'Training/Licence',
    },
    ADDRESS: {
      PRIMARY_ADDRESS: 'Primary Address',
      SECONDARY_ADDRESS: 'Secondary Address',
      ADD_NEW: 'Add New',
      NO_DATA_AVAILABLE: 'No Data Available',
    },
    CONTACT: {
      PRIMARY_CONTACT: 'Primary Contact',
      SECONDARY_CONTACT: 'Emergency Contact',
      ADD_NEW: 'Add New',
      NO_DATA_AVAILABLE: 'No Data Available',
    },
    BUSINESS: {
      BUSINESS_ROLE: 'Role Detail',
      BUSINESS_RIGHTS: 'Permission',
    },
    LEAVE_LIST: {
      HALF_DAY: 'Half Day',
      FULL_DAY: 'Full Day',
      APPROVED_BY: 'APPROVED BY',
    },
    EMPLOYEE_TRAINING_LICENSE: {
      START_ON: 'Start on',
      END_ON: 'End on',
    },
    FORM_CONTROL: {
      EMAIL: {
        LABEL: 'Email',
        PLACE_HOLDER: 'Enter Email',
        PATTERN: 'Email is invalid.',
        HINT: 'We\'ll never share your email with anyone else.',
      },
      PASSWORD: {
        LABEL: 'Password',
        PLACE_HOLDER: 'Enter Password',
        PATTERN: 'Password is invalid.',
      },
      NAME: {
        LABEL: 'Name',
        PLACE_HOLDER: 'Enter  Name',
      },
      CONTACT_PERSON: {
        LABEL: 'Contact Person Name',
        PLACE_HOLDER: 'Contact Person Name',
      },
      FIRST_NAME: {
        LABEL: 'First Name',
        PLACE_HOLDER: 'Enter First Name',
      },
      LAST_NAME: {
        LABEL: 'Last Name',
        PLACE_HOLDER: 'Enter Last Name',
      },
      TERMS: {
        LABEL: 'I agree terms and conditions',
        VALIDATION: {
          REQUIRED: 'Please agree terms and condition',
        },
      },
      CONFIRM_PASSWORD: {
        LABEL: 'Confirm Password',
        PLACE_HOLDER: 'Re-enter Password',
        PATTERN: 'Password is invalid.',
      },
      BUSINESS_NAME: {
        LABEL: 'Business Name',
        PLACE_HOLDER: 'Enter Business Name',
      },
      ADDRESS_ONE: {
        LABEL: 'Address Line 1',
        PLACE_HOLDER: 'Enter Address Line One',
      },
      ADDRESS_TWO: {
        LABEL: 'Address Line 2',
        PLACE_HOLDER: 'Enter Address Line Two',
      },
      CITY: {
        LABEL: 'City',
        PLACE_HOLDER: 'Enter City',
      },
      PINCODE: {
        LABEL: 'Pincode',
        PLACE_HOLDER: 'Enter Pincode',
      },
      COUNTRY: {
        LABEL: 'Country',
        PLACE_HOLDER: 'Enter Country',
      },
      STATE: {
        LABEL: 'State',
        PLACE_HOLDER: 'Enter State',
      },
      TIMEZONE: {
        LABEL: 'Timezone',
        PLACE_HOLDER: 'Enter Timezone',
      },
      CHOOSE_EXISTING_BUSINESS: {
        LABEL: 'Choose Existing Business',
        INFO: 'Is your team already using IQCheckPoint?',
      },
      CREATE_NEW_BUSINESS: {
        LABEL: 'Create New Business',
        INFO: 'Do you own a business or manage a team?',
      },
      EXISTING_BUSINESS: {
        LABEL: 'Select Business',
        PLACE_HOLDER: 'Select Business',
      },
      HOLIDAY_NAME: {
        LABEL: 'Holiday Name',
        PLACE_HOLDER: 'Holiday Name',
      },
      HOLIDAY_START_DATE: {
        LABEL: 'Holiday Start Date',
        PLACE_HOLDER: 'Holiday Start Date',
      },
      HOLIDAY_END_DATE: {
        LABEL: 'Holiday End Date',
        PLACE_HOLDER: 'Holiday End Date',
      },
      HOLIDAY_EXPORT_CODE: {
        LABEL: 'Holiday Export Code',
        PLACE_HOLDER: 'Holiday Export Code',
        TOOLTIP: 'It will be used to map the fields with third-party system',
      },
      TRAINING_LICENSE_NAME: {
        LABEL: 'Training/Licence Name',
        PLACE_HOLDER: 'Training/Licence Name',
      },
      STRESS_PROFILE_NAME: {
        LABEL: 'Stress Profile Name',
        PLACE_HOLDER: 'Stress Profile Name',
        TOOLTIP: 'Stress management is a great way to control fatigue and overtime for your employees. You can control the following attributes of how and when stress warning will trigger with IQCheckPoint',
      },
      STRESS_PROFILE_MAX_HOURS_SHIFT: {
        LABEL: 'Max Hours Per Shift',
        PLACE_HOLDER: 'Max Hours Per Shift',
      },
      STRESS_PROFILE_MAX_HOURS_WEEK: {
        LABEL: 'Max Hours Per Week',
        PLACE_HOLDER: 'Max Hours Per Week',
      },
      STRESS_PROFILE_MAX_HOURS_DAY: {
        LABEL: 'Max Hours per Day',
        PLACE_HOLDER: 'Max Hours per Day',
      },
      STRESS_PROFILE_MAX_DAYS_WEEK: {
        LABEL: 'Max Days Per Week',
        PLACE_HOLDER: 'Max Days Per Week',
      },
      STRESS_PROFILE_MIN_HOURS_OVERNIGHT: {
        LABEL: 'Min Hours between Overnight',
        PLACE_HOLDER: 'Min Hours between Overnight',
        TOOLTIP: 'Only applicable for shifts finishing after 7pm and subsequent shift starting before 9AM next morning',
      },
      LEAVE_NAME: {
        LABEL: 'Leave Name',
        PLACE_HOLDER: 'Leave Name',
      },
      LEAVE_EXPORT_CODE: {
        LABEL: 'Leave Export Code',
        PLACE_HOLDER: 'Leave Export Code',
        TOOLTIP: 'It will be used to map the fields with third-party system',
      },
      LEAVE_TYPE: {
        LABEL: 'Leave Type',
      },
      BUSINESS_LOGO: {
        LABEL: 'Business Logo',
        PLACE_HOLDER: 'Business Logo',
      },
      BUSINESS_VAT_ID: {
        LABEL: 'VAT ID',
        PLACE_HOLDER: 'VAT ID',
      },
      BUSINESS_GST_ID: {
        LABEL: 'GST ID',
        PLACE_HOLDER: 'GST ID',
      },
      BUSINESS_DATE_FORMAT: {
        LABEL: 'Date Format',
        PLACE_HOLDER: 'Date Format',
      },
      BUSINESS_TIME_FORMAT: {
        LABEL: 'Time Format',
        PLACE_HOLDER: 'Time Format',
      },
      BUSINESS_ALLOW_SMS: {
        LABEL: 'Allow SMS Notifications (Charges apply)',
        PLACE_HOLDER: 'Allow SMS Notifications (Charges apply)',
      },
      BUSINESS_COLOR: {
        LABEL: 'Business Color',
        PLACE_HOLDER: 'Business Color',
      },
      BUSINESS_REWARD: {
        LABEL: 'Reward Point',
        PLACE_HOLDER: 'Reward Point',
      },
      BUSINESS_SHIFT_START: {
        LABEL: 'Buffer Reward Time for Start Shift (In Minute)',
        PLACE_HOLDER: 'Buffer Reward Time for Start Shift (In Minute)',
      },
      COUNTRY_CODE: {
        LABEL: 'Country Code',
        PLACE_HOLDER: 'Enter Country Code',
      },
      BUSINESS_SHIFT_END: {
        LABEL: 'Buffer Reward Time  for End Shift (In Minute)',
        PLACE_HOLDER: 'Buffer Reward Time  for End Shift (In Minute)',
      },
      CLIENT_NAME: {
        LABEL: 'Client Name',
        PLACE_HOLDER: 'Client Name',
      },
      CONTACT_PERSON_FIRST_NAME: {
        LABEL: 'Contact Person First Name',
        PLACE_HOLDER: 'Contact Person First Name',
      },
      CONTACT_PERSON_LAST_NAME: {
        LABEL: 'Contact Person Last Name',
        PLACE_HOLDER: 'Contact Person Last Name',
      },
      CONTACT_PERSON_EMAIL: {
        LABEL: 'Contact Person Email Address',
        PLACE_HOLDER: 'Contact Person Email Address',
        TOOLTIP: 'This email address will be used for login access',
      },
      CONTACT_PERSON_MOBILE_NUMBER: {
        LABEL: 'Contact Person Mobile Number',
        PLACE_HOLDER: 'Contact Person Mobile Number',
      },
      CLIENT_ADDITIONAL_EMAIL: {
        LABEL: 'Additional Recipients Email Address [Please type email address and press enter]',
        PLACE_HOLDER: 'Additional Recipients',
      },
      CLIENT_INCIDENT_REPORT_EMAIL: {
        LABEL: 'Incident Report by Email',
        PLACE_HOLDER: 'Incident Report by Email',
      },
      CLIENT_LOGIN_UNABLE: {
        LABEL: 'Enable Login',
        PLACE_HOLDER: 'Enable Login',
      },
      CLIENT_REWARD_SETTING_UNABLE: {
        LABEL: 'Do you want to change the Busines Level Reward setting?',
        PLACE_HOLDER: 'Do you want to change the Busines Level Reward setting?',
      },
      CLIENT_REWARD_BUFFER_END_SHIFT: {
        LABEL: 'Buffer Reward Time  for ClockOut (In Minute)',
        PLACE_HOLDER: 'Buffer Reward Time  for ClockOut (In Minute)',
      },
      CLIENT_REWARD_BUFFER_START_SHIFT: {
        LABEL: 'Buffer Reward Time for ClockIn (In Minute)',
        PLACE_HOLDER: 'Buffer Reward Time for ClockIn (In Minute)',
      },
      CLIENT_REWARD_POINT: {
        LABEL: 'Reward Point',
        PLACE_HOLDER: 'Reward Point',
      },
      CLIENT_ARCHIVE: {
        LABEL: 'Do you want archive this client and all it\'s data?',
        PLACE_HOLDER: 'Do you want archive this client and all it\'s data?',
      },
      EMAIL_ADDRESS: {
        LABEL: 'Email Address',
        PLACE_HOLDER: 'Email Address',
        TOOLTIP: 'This email address will be used for login access',
      },
      PHONE_NUMBER: {
        LABEL: 'Phone Number',
        PLACE_HOLDER: 'Phone Number',
      },
      BIRTH_DATE: {
        LABEL: 'Date Of Birth',
        PLACE_HOLDER: 'Date Of Birth',
      },
      PROFILE_IMAGE: {
        LABEL: 'Profile Image',
        PLACE_HOLDER: 'Profile Image',
      },
      GENDER: {
        LABEL: 'Gender',
        PLACE_HOLDER: 'Gender',
      },
      MARITAL_STATUS: {
        LABEL: 'Married/Single',
        PLACE_HOLDER: 'Married/Single',
      },
      ANNIVERSARY_DATE: {
        LABEL: 'Anniversary Date',
        PLACE_HOLDER: 'Anniversary Date',
      },
      EMERGENCEY_PHONE_ONE: {
        LABEL: 'Emergency Phone - 1',
        PLACE_HOLDER: 'Emergency Phone One',
      },
      EMERGENCEY_PHONE_TWO: {
        LABEL: 'Emergency Phone - 2',
        PLACE_HOLDER: 'Emergency Phone Two',
      },
      EMERGENCEY_CONTACT_NAME_ONE: {
        LABEL: 'Emergency Contact Name - 1',
        PLACE_HOLDER: 'Emergency Contact Name One',
      },
      EMERGENCEY_CONTACT_NAME_TWO: {
        LABEL: 'Emergency Contact Name - 2',
        PLACE_HOLDER: 'Emergency Contact Name Two',
      },
      EMPLOYEE_PAY_RATE_TYPE: {
        LABEL: 'Hourly / Salary',
        PLACE_HOLDER: 'Select',
      },
      EMPLOYEE_PAY_RATE_SUNDAY: {
        LABEL: 'Sunday Hourly Rate',
        PLACE_HOLDER: 'Sunday Hourly Rate',
      },
      EMPLOYEE_PAY_RATE_TUESDAY: {
        LABEL: 'Tuesday Hourly Rate',
        PLACE_HOLDER: 'Tuesday Hourly Rate',
      },
      EMPLOYEE_PAY_RATE_MONDAY: {
        LABEL: 'Monday Hourly Rate',
        PLACE_HOLDER: 'Monday Hourly Rate',
      },
      EMPLOYEE_PAY_RATE_WEDNESDAY: {
        LABEL: 'Wednesday Hourly Rate',
        PLACE_HOLDER: 'Wednesday Hourly Rate',
      },
      EMPLOYEE_PAY_RATE_THURSDAY: {
        LABEL: 'Thursday  Hourly Rate',
        PLACE_HOLDER: 'Thursday  Hourly Rate',
      },
      EMPLOYEE_PAY_RATE_FRIDAY: {
        LABEL: 'Friday Hourly Rate',
        PLACE_HOLDER: 'Friday Hourly Rate',
      },
      EMPLOYEE_PAY_RATE_SATURDAY: {
        LABEL: 'Saturday Hourly Rate',
        PLACE_HOLDER: 'Saturday Hourly Rate',
      },
      EMPLOYEE_PAY_RATE_PUBLIC_HOLIDAY: {
        LABEL: 'Public Holiday Rate',
        PLACE_HOLDER: 'Public Holiday Rate',
      },
      EMPLOYEE_PAY_RATE_OVERTIME_HOURS: {
        LABEL: 'Overtime Hours',
        PLACE_HOLDER: 'Overtime Hours',
      },
      EMPLOYEE_PAY_RATE_OVERTIME_RATE: {
        LABEL: 'Overtime Rate',
        PLACE_HOLDER: 'Overtime Rate',
      },
      EMPLOYEE_PAY_RATE_OVERTIME_FACTOR: {
        LABEL: 'Overtime Factor',
        PLACE_HOLDER: 'Overtime Factor',
      },
      EMPLOYEE_PAY_RATE_OVERTIME_UNABLE: {
        LABEL: 'Giving Overtime?',
        PLACE_HOLDER: 'Giving Overtime?',
      },
      EMPLOYEE_PAY_RATE_SALARY_AMOUNT: {
        LABEL: 'Salary Amount',
        PLACE_HOLDER: 'Salary Amount',
      },
      EMPLOYEE_PAY_RATE_EXPORT_CODE: {
        LABEL: 'Export Codes',
        PLACE_HOLDER: 'Export Codes',
      },
      EMPLOYEE_CLIENT_LIST: {
        LABEL: 'Work At (Clients) (Multiple)',
        PLACE_HOLDER: 'Work At (Clients) (Multiple)',
      },
      EMPLOYEE_CLIENT_LOCATION: {
        LABEL: 'Work At (Locations) (Multiple)',
        PLACE_HOLDER: 'Work At (Locations) (Multiple)',
      },
      EMPLOYEE_HIRED_DATE: {
        LABEL: 'Hired on',
        PLACE_HOLDER: 'Hired on',
      },
      EMPLOYEE_ACCESS_LEVEL: {
        LABEL: 'Access Level',
        PLACE_HOLDER: 'Access Level',
      },
      STRESS_PROFILE_LIST: {
        LABEL: 'Stress Profile',
        PLACE_HOLDER: 'Stress Profile',
      },
      ACCOUNT_HOLDER_NAME: {
        LABEL: 'Account Holder Name',
        PLACE_HOLDER: 'Account Holder Name',
      },
      BSB_NUMBER: {
        LABEL: 'BSB Number',
        PLACE_HOLDER: 'BSB Number',
      },
      ACCOUNT_NUMBER: {
        LABEL: 'Account Number',
        PLACE_HOLDER: 'Account Number',
      },
      WEEK_START: {
        LABEL: 'Week starts with',
        PLACE_HOLDER: 'Week starts with',
        HINT: 'Which day of the week does your week start with? This will determine the start day in activities such as Scheduling and calendar selection.',
      },
      LOCATION_OPEN_TIME: {
        LABEL: 'Location open time',
        PLACE_HOLDER: 'Location open time',
        HINT: 'Please specify the time your location opens.',
      },
      LOCATION_CLOSE_TIME: {
        LABEL: 'Location close time',
        PLACE_HOLDER: 'Location close time',
        HINT: 'Please specify the time your location closes.',
      },

      SHIFT_DURATION: {
        LABEL: 'Default shift duration (hours)',
        PLACE_HOLDER: 'Default shift duration (hours)',
        HINT: 'Default shift length when creating a shift in Rostering.',
      },
      MEAL_BREAK_DURATION: {
        LABEL: 'Default meal break duration (minutes)',
        PLACE_HOLDER: 'Default meal break duration (minutes)',
        HINT: 'Default meal break length for shifts that get created in Rostering.',
      },
      PREVENT_MODIFICATION: {
        LABEL: 'Prevent modification',
        PLACE_HOLDER: 'Prevent modification',
        HINT: 'System will prevent any changes to an unworked rostered shift.',
      },
      SHIFT_NOTIFICATION: {
        LABEL: 'Shift Notifications',
        PLACE_HOLDER: 'Shift Notifications',
        HINT: 'Select who should receive Shift notifications such as Late employee notifications & Shift Swap approvals.',
      },
      SHIFT_CONFIRMATION: {
        LABEL: 'Require shift confirmation',
        PLACE_HOLDER: 'Require shift confirmation',
        HINT: 'If published rosters are not confirmed by this timeframe, it will be automatically turned into open shift.',
      },
      VIEW_OTHER_PROFILE: {
        LABEL: `Allow employees to view each other's schedule`,
        PLACE_HOLDER: `Allow employees to view each other's schedule`,
        HINT: 'Are employees allowed to view their co-worker schedules?',
      },
      ALLOW_SWAP_SHIFT: {
        LABEL: 'Allow employees to swap shifts',
        PLACE_HOLDER: 'Allow employees to swap shifts',
        HINT: 'If viewing other employees schedules is also enabled, this setting will allow employees to swap shifts - i.e. trade a shift they can not work for a specific shift which another employee is scheduled to work. Employees will only be able to swap where both parties are qualified to work the others shift. Employees remain responsible for their shift unless and until someone else accepts the shift. Manager approval can be set ON or OFF using the setting below.',
      },

      REQUIRE_MANAGER_APPROVAL: {
        LABEL: 'Require manager approval before a swap is final',
        PLACE_HOLDER: 'Require manager approval before a swap is final',
        HINT: 'If selected, an employee can accept a swap request, however the swap must be approved (by the manager who created the shift of the employee who requested the swap OR the manager who created the shift of the employee who accepted the swap).',
      },
      ALLOW_OFFER_SHIFT: {
        LABEL: 'Allow employees to offer shifts',
        PLACE_HOLDER: 'Allow employees to offer shifts',
        HINT: 'Sometimes an employee can not work a scheduled shift, and it is preferable to let them find a solution. This option allows employees to offer their shift to other employees who are qualified to pick up the shift. Employees remain responsible for their shift unless and until someone else accepts the shift. Please note that manager approval is NOT required, but managers will receive a notification when an offered shift is accepted.',
      },
      CLOCK_IN_BROWSER: {
        LABEL: 'Allow employees to clock in via Web browser',
        PLACE_HOLDER: 'Allow employees to clock in via Web browser',
        HINT: 'Allow employees to start, pause and end their shifts in a Web browser.',
      },
      CLOCK_IN_MOBILE: {
        LABEL: 'Allow employees to clock in via Mobile device',
        PLACE_HOLDER: 'Allow employees to clock in via Mobile device',
        HINT: 'Allow employees to start, pause and end their shifts with a mobile device',
      },
      REQUIRE_PHOTO: {
        LABEL: 'Require photo when starting, ending shifts in Kiosk',
        PLACE_HOLDER: 'Require photo when starting, ending shifts in Kiosk',
        HINT: 'Require a photo to be taken when employees start and end their shifts in Kiosk.',
      },
      ALLOW_SUBMIT_ADHOC_DOC: {
        LABEL: 'Allow submitting ad-hoc timesheets via Web or Mobile',
        PLACE_HOLDER: 'Allow submitting ad-hoc timesheets via Web or Mobile',
        HINT: 'Enabling this will allow employees to amend existing timesheets & create timesheets in the past via Web or Mobile (excludes Time Clock & Kiosk on Tablet). Disabling this will only allow employees to amend the timesheet if decreasing the time. User will also not be able to create timesheets in the past.',
      },
      ALLOW_EMP_MODIFY: {
        LABEL: 'Allow Employees to Modify Timesheet',
        PLACE_HOLDER: 'Allow Employees to Modify Timesheet',
        HINT: 'Enabling this will allow employees to modify their timesheet prior to ending shift. Disabling this will block any edits to timesheet prior to ending shift.',
      },
      SUBMISSION_PRIOR_TO_SHIFT: {
        LABEL: 'Submission prior to shift end (minutes)',
        PLACE_HOLDER: 'Submission prior to shift end (minutes)',
        HINT: 'An employee may submit their time sheet this many minutes before the scheduled end time.',
      },
      MIN_LENGTH_TIME_SHEET: {
        LABEL: 'Minimum length of time sheets (minutes)',
        PLACE_HOLDER: 'Minimum length of time sheets (minutes)',
        HINT: 'Time sheets that are submitted via mobile and are shorter than this value shall get automatically deleted.',
      },
      ENABLE_AUTO_ROUNDING: {
        LABEL: 'Enable auto-rounding of real-time time sheets',
        PLACE_HOLDER: 'Enable auto-rounding of real-time time sheets',
        HINT: 'When auto-rounding of time sheets is enabled for a location, then time sheets that are submitted in that location via mobile or Kiosk shall get their start time, end time and break length rounded according to the corresponding settings.',
      },
      ROUND_START_TIME: {
        LABEL: 'Round start time of time sheets',
        PLACE_HOLDER: 'Round start time of time sheets',
        HINT: `Select a preference for rounding the start time of time sheets. This will be applied by selecting 'round' in Approve Time Sheets or the enabling of the auto-round setting.`,
      },
      ROUND_END_TIME: {
        LABEL: 'Round end time of time sheets',
        PLACE_HOLDER: 'Round end time of time sheets',
        HINT: `Select a preference for rounding the end time of time sheets. This will be applied by selecting 'round' in Approve Time Sheets or the enabling of the auto-round setting.`,
      },
      ROUND_BREAK_TIME: {
        LABEL: 'Round break of time sheets',
        PLACE_HOLDER: 'Round break of time sheets',
        HINT: `Select a preference for rounding the break of time sheets. This will be applied by selecting 'round' in Approve Time Sheets or the enabling of the auto-round setting.`,
      },
      ROUND_START_TIME_SCHEDULED_EARLIER: {
        LABEL: 'Round start time of time sheets to scheduled if it is earlier',
        PLACE_HOLDER: 'Round start time of time sheets to scheduled if it is earlier',
        HINT: `Select 'yes' if a time sheet should always start at the scheduled time or later. If the start time is later, your rounding preference may be selected above. This will be applied by selecting 'round' in Approve Time Sheets or the enabling of the auto-round setting.`,
      },
      ROUND_END_TIME_SCHEDULED_LATER: {
        LABEL: 'Round end time of time sheets to scheduled if it is later',
        PLACE_HOLDER: 'Round end time of time sheets to scheduled if it is later',
        HINT: `Select 'yes' if a time sheet should always finish at the scheduled time or earlier. If the end time is earlier, your rounding preference may be selected above. This will be applied by selecting 'round' in Approve Time Sheets or the enabling of the auto-round setting`,
      },
      ROUND_BREAK_TIME_SCHEDULED: {
        LABEL: 'Round break of time sheets to scheduled if it is shorter',
        PLACE_HOLDER: 'Round break of time sheets to scheduled if it is shorter',
        HINT: `Select 'yes' if a time sheet break should always be the same or longer than the scheduled break. If the break is longer, your rounding preference may be selected above. This will be applied by selecting 'round' in Approve Time Sheets or the enabling of the auto-round setting.`,
      },
      AUTO_TIME_APPROVE: {
        LABEL: 'Auto time-approve real-time time sheets',
        PLACE_HOLDER: 'Auto time-approve real-time time sheets',
        HINT: `Select an option for time sheets to be automatically time approved. As soon as a time sheet that corresponds to a scheduled shift is submitted via mobile or Kiosk within the selected variance, it will be set to a time approved state.`,
      },
      ALLOW_EMPLOYEE_CLOCK_IN: {
        LABEL: 'Allow Employees to clock in early to Shift',
        PLACE_HOLDER: 'Allow Employees to clock in early to Shift',
        HINT: 'Enabling this will allow employees to clock in early to their shift. Disabling this will block employees from clocking in early before specified time buffer.',
      },
      LINK_UNSCHEDULED_TIMESHEET: {
        LABEL: 'Link unscheduled timesheet with scheduled shift',
        PLACE_HOLDER: 'Link unscheduled timesheet with scheduled shift',
        HINT: 'Select how unscheduled timesheets are linked to a scheduled shift within the same day. The default option (Best Fit) will link when an unscheduled timesheet starts 8 hours before or after a scheduled shift.',
      },
      ALLOW_EMPLOYEE_CLOCK_MINUTE_BEFORE: {
        LABEL: 'Allow Employees to clock in X minutes before shift scheduled start',
        PLACE_HOLDER: 'Allow Employees to clock in X minutes before shift scheduled start',
        HINT: 'Please specify how many minutes before before the shift scheduled start, that an employee is allowed to clock in',
      },
      ALLOW_EMPLOYEE_END_BREAK_EARLY: {
        LABEL: 'Allow Employees to End Break Early',
        PLACE_HOLDER: 'Allow Employees to End Break Early',
        HINT: 'Enabling this will allow employees to end their break early. Disabling this will block employees from ending their break early (based on scheduled break duration)',
      },
      AUTO_SUGGEST_BREAK: {
        LABEL: 'Auto Suggest Breaks',
        PLACE_HOLDER: 'Auto Suggest Breaks',
        HINT: `Enabling this will automatically suggest break duration for breaks not taken by an employee at end of shift. Suggested break duration will be based off the employee's schedule. Disabling this will not automatically suggest break duration at end of shift`,
      },
      DISPLAY_BREAK_WARNINGS: {
        LABEL: 'Display Break Warnings',
        PLACE_HOLDER: 'Display Break Warnings',
        HINT: `In 'Approve Timesheets', there will be warnings displayed for missed breaks & if breaks are shorter in duration than scheduled.`,
      },
      ARCHIVE_LOCATION: {
        LABEL: `Do you want archive this location and all it's data?`,
        PLACE_HOLDER: 'Display Break Warnings',
      },
      LOCATION_NAME: {
        LABEL: 'Location Name',
        PLACE_HOLDER: 'Location Name',
      },
      LOCATION_ADDRESS: {
        LABEL: 'Address',
        PLACE_HOLDER: 'Address',
      },
      AREA_NAME: {
        LABEL: 'Point Name',
        PLACE_HOLDER: 'Point Name',
      },
      AREA_ADDRESS: {
        LABEL: 'Address',
        PLACE_HOLDER: 'Address',
      },
      TASK_GROUP_NAME: {
        LABEL: 'Task Group Name',
        PLACE_HOLDER: 'Task Group Name',
      },
      TASK_NAME: {
        LABEL: 'Task Name',
        PLACE_HOLDER: 'Task Name',
      },
      TASK_NOTE: {
        LABEL: 'Task Note',
        PLACE_HOLDER: 'Task Note',
      },
      TASK_MULTIPLE_ENABLE: {
        LABEL: 'Multiple times?',
        PLACE_HOLDER: 'Multiple times?',
      },
      TASK_GROUP_REPEAT_MONDAY: {
        LABEL: 'Monday',
        PLACE_HOLDER: 'Monday',
      },
      TASK_GROUP_REPEAT_TUESDAY: {
        LABEL: 'Tuesday',
        PLACE_HOLDER: 'Tuesday',
      },
      TASK_GROUP_REPEAT_WEDNESDAY: {
        LABEL: 'Wednesday',
        PLACE_HOLDER: 'Wednesday',
      },
      TASK_GROUP_REPEAT_THURSDAY: {
        LABEL: 'Thursday',
        PLACE_HOLDER: 'Thursday',
      },
      TASK_GROUP_REPEAT_FRIDAY: {
        LABEL: 'Friday',
        PLACE_HOLDER: 'Friday',
      },
      TASK_GROUP_REPEAT_SATURDAY: {
        LABEL: 'Saturday',
        PLACE_HOLDER: 'Saturday',
      },
      TASK_GROUP_REPEAT_SUNDAY: {
        LABEL: 'Sunday',
        PLACE_HOLDER: 'Sunday',
      },
      TASK_GROUP_REPEAT_PUBLIC_HOLIDAY: {
        LABEL: 'Public Holiday',
        PLACE_HOLDER: 'Public Holiday',
      },
      TASK_GROUP_FROM_TIME: {
        LABEL: 'From Time',
        PLACE_HOLDER: 'Select',
      },
      TASK_GROUP_TO_TIME: {
        LABEL: 'To Time',
        PLACE_HOLDER: 'Select',
      },
      TASK_GROUP_TYPE_INDIVIDUAL_GROUP: {
        LABEL: 'Task Type',
        PLACE_HOLDER: 'Task Type',
      },
      ASSIGN_TO: {
        LABEL: 'Assign To',
        PLACE_HOLDER: 'Select',
      },
      TASK_GROUP_TO_DATE: {
        LABEL: 'To Date',
        PLACE_HOLDER: 'Select',
      },
      TASK_GROUP_FROM_DATE: {
        LABEL: 'Fron Date',
        PLACE_HOLDER: 'Select',
      },
      AREA_NFC: {
        LABEL: 'NFC',
        PLACE_HOLDER: 'NFC',
      },
      AREA_QR_CODE: {
        LABEL: 'QR Code',
        PLACE_HOLDER: 'QR Code',
      },
      AREA_BEACON: {
        LABEL: 'Beacon',
        PLACE_HOLDER: 'Beacon',
      },
      AREA_GPS_ENABLE: {
        LABEL: 'Send GPS Coordinates',
        PLACE_HOLDER: 'Send GPS Coordinates',
      },
      AREA_TRAINING_LICENSE: {
        LABEL: 'Training/Licence',
        PLACE_HOLDER: 'Training/Licence',
      },
      AREA_TASK_GROUP: {
        LABEL: 'Task Group',
        PLACE_HOLDER: 'Task Group',
      },
      AREA_REMARK: {
        LABEL: 'Remark',
        PLACE_HOLDER: 'Remark',
      },
      // Core
      NUMBER: {
        LABEL: 'Number',
        PLACE_HOLDER: 'Enter number',
      },
      DATE: {
        LABEL: 'Date',
        PLACE_HOLDER: 'Select Date',
      },
      SELECT: {
        LABEL: 'Select',
        PLACE_HOLDER: 'Select',
      },
      SWITCH: {
        LABEL: 'Switch',
        PLACE_HOLDER: 'Switch',
      },
      MARRIED_TYPE: {
        LABEL: 'Married Type',
        PLACE_HOLDER: 'Select',
      },
      FILE_UPLOAD: {
        LABEL: 'Upload Document',
        PLACE_HOLDER: 'Upload File',
      },
      TEXTAREA_NOTES: {
        LABEL: 'Notes',
        PLACE_HOLDER: 'Enter notes',
      },
      TRAINING_LICENSE_TYPE: {
        LABEL: 'Training/License',
        PLACE_HOLDER: 'Training/License',
      },
      TRAINING_LICENSE_START_DATE: {
        LABEL: 'Start Date',
        PLACE_HOLDER: 'Select Date',
      },
      TRAINING_LICENSE_EXPIRY_DATE: {
        LABEL: 'Expiry Date',
        PLACE_HOLDER: 'Select Date',
      },
      LEAVE_NOTE: {
        LABEL: 'Leave Notes',
      },
      FULL_DAY: {
        LABEL: 'Full Day',
      },
      HALF_DAY: {
        LABEL: 'Half Day',
      },
      FROM_DATE: {
        LABEL: 'From date',
        PLACE_HOLDER: 'Select Date',
      },
      TO_DATE: {
        LABEL: 'To date',
        PLACE_HOLDER: 'Select Date',
      },
      FROM_TIME: {
        LABEL: 'From Time',
        PLACE_HOLDER: 'Select',
      },
      TO_TIME: {
        LABEL: 'To Time',
        PLACE_HOLDER: 'Select',
      },
      POINT_TYPE: {
        LABEL: 'Point Type',
        PLACE_HOLDER: 'Point Type',
      },
      MONDAY: {
        LABEL: 'Monday',
        PLACE_HOLDER: 'Monday',
      },
      TUESDAY: {
        LABEL: 'Tuesday',
        PLACE_HOLDER: 'Tuesday',
      },
      WEDNESDAY: {
        LABEL: 'Wednesday',
        PLACE_HOLDER: 'Wednesday',
      },
      THURSDAY: {
        LABEL: 'Thursday',
        PLACE_HOLDER: 'Thursday',
      },
      FRIDAY: {
        LABEL: 'Friday',
        PLACE_HOLDER: 'Friday',
      },
      SATURDAY: {
        LABEL: 'Saturday',
        PLACE_HOLDER: 'Saturday',
      },
      SUNDAY: {
        LABEL: 'Sunday',
        PLACE_HOLDER: 'Sunday',
      },
      UNAVAIBILITY_NOTE: {
        LABEL: 'Notes',
        PLACE_HOLDER: 'Reason for unavaibility',
      },
      UNAVAIBILITY_REPEAT: {
        LABEL: 'Repeat',
        PLACE_HOLDER: 'Repeat',
      },
      UNAVAIBILITY_EVERY_WEEK_END_DATE: {
        LABEL: 'End On a Date',
        PLACE_HOLDER: 'Select Date',
      },
      ALL_DAY: {
        LABEL: 'All day',
        PLACE_HOLDER: '',
      },
      UNAVAIBILITY_EVERY: {
        LABEL: 'Every',
        PLACE_HOLDER: '',
      },
      UNAVAIBILITY_ON: {
        LABEL: 'On',
        PLACE_HOLDER: '',
      },
      NEVER_END: {
        LABEL: 'Never End',
        PLACE_HOLDER: 'Never End',
      },
      ROLE_NAME: {
        LABEL: 'Role Name',
        PLACE_HOLDER: 'Role Name',
      },
      ROLE_ASSOCIATE: {
        LABEL: 'Role Associate',
        PLACE_HOLDER: 'Role Associate',
      },
      SHARE_WITH: {
        LABEL: 'Share With',
        PLACE_HOLDER: 'Share With',
      },
      MARK_POST_AS_CONFIRMED: {
        LABEL: 'All readers will be required to mark this post as confirmed. You can track who has and hasn’t confirmed.',
        PLACE_HOLDER: 'All readers will be required to mark this post as confirmed. You can track who has and hasn’t confirmed.',
      },
      POST: {
        PLACE_HOLDER: `What's Happening`,
        LABEL: 'Description',
      },
      LOOP_NAME: {
        LABEL: 'Loop Name',
      },
      LOOP_BUFFER: {
        LABEL: 'Loop Buffer',
      },
      LOOP_INTERVAL: {
        LABEL: 'Loop Interval',
      },
      DASHBOARD_NAME: {
        LABEL: 'Dashboard Name',
      },
      DASHBOARD_DESCRIPTION: {
        LABEL: 'Dashboard Description',
      },
      DASHBOARD_PROPERTIES: {
        LABEL: 'Dashboard Properties',
      },
      DASHBOARD_TYPE: {
        LABEL: 'Dashboard Type',
      },
      WIDGET_NAME: {
        LABEL: 'Widget Name',
      },
      WIDGET_DESCRIPTION: {
        LABEL: 'Widget Description',
      },
    },


    TITLE: {
      /////////////// AUTH //////////////
      //// LOGIN ////
      LOGIN_TITLE: 'Sign In',
      LOGOUT_TITLE: 'Logout',
      //// REGISTER ////
      REGISTER_TITLE: 'Sign Up',
      FORGOT_PASSWORD_TITLE: 'Forget Password',
      RESET_PASSWORD_TITLE: 'Reset Password',
      RESET_TOKEN_TITLE: 'Validate Reset Token',
      // BUSINESS ////
      CREATE_BUSINESS_TITLE: 'Create Business',
      UPDATE_CLIENT_TITLE: 'Update Client',
      SELECT_BUSINESS_TITLE: 'Business',
      BUSINESS_TITLE: 'Business',
      SESSION_TIMEOUT_TITLE: 'Time Out',
      SELECT_BUSINESS: 'Select Business',
      PENDING_BUSINESS_USER_TITLE: 'Pending Users',
      CHANGE_BUSINESS_TITLE: 'Business',

      /////////////// MASTER BUSINESS ///////////////
      // PUBLIC HOLIDAY
      PUBLIC_HOLIDAY_TITLE: 'Public Holiday',
      // TRAINING LICENSE
      TRAINING_LICENSE_TITLE: 'Training/License',
      // STRESS PROFILE
      STRESS_PROFILE_TITLE: 'Stress Profile',
      // LEAVE
      LEAVE_TITLE: 'Leave',
      // BUSINESS SETTING
      BUSINESS_SETTING_TITLE: 'Business Setting',
      // EMPLOYEE
      CREATE_EMPLOYEE_TITLE: 'Create Employee',
      UPDATE_EMPLOYEE_TITLE: 'Update Employee',
      DELETE_EMPLOYEE_TITLE: 'Delete Employee',
      EMPLOYEE_TITLE: 'Employee',
      // CLIENT
      CREATE_CLIENT_TITLE: 'Create Client',
      UPDATE_CLIENT_REWARD_TITLE: 'Update Client Reward',
      UPDATE_CLIENT_SETTING_TITLE: 'Update Client Setting',
      UPDATE_CLIENT_CONTACT_TITLE: 'Update Client Contact',
      UPDATE_CLIENT_ADDRESS_TITLE: 'Update Client Address',
      INSERT_CLIENT_CONTACT_TITLE: 'Client Contact',
      INSERT_CLIENT_ADDRESS_TITLE: 'Client Address',
      DELETE_CLIENT_TITLE: 'Client',
      INVITE_CLIENT_TITLE: 'Invite Client',
      CLIENT_LOCATION_TITLE: 'Client Location',
      CLIENT_AREA_TITLE: 'Client Area',
      CLIENT_LOCATION_TIMESHEET: 'Timesheet',
      CLIENT_LOCATION_SCHEDULING: 'Scheduling',
      // TASK
      TASK_GROUP_LOCATION_TITLE: 'Task Group Location',
      TASK_GROUP_AREA_TITLE: 'Task Group Area',
      TASK_GROUP_PERSONAL_TITLE: 'Task Group Personal',
      TASK_GROUP_TITLE: 'Task Group',
      TASK_GROUP_CHILD_TITLE: 'Task Group Child',
      // USER
      USER_CONTACT_TITLE: 'USER CONTACT',
      USER_ADRESS_TITLE: 'User Address',
      // BUSINESS ROLE
      BUSINESS_ROLE_TITLE: 'Business Role',
      // REQUEST
      USER_REQUEST_TITLE: 'User Request',
      // NEWS FEED
      NEWS_FEED_TITLE: 'News Feed',
      //
      LOOP: 'Loop',
      DASHBOARD: 'Dashboard',
      DASHBOARD_WIDGET: 'Dashboard Widget',
      LEAVE_REQUEST: 'Leave Request',

    },
    ERROR: {
      VALIDATION: {
        REQUIRED: ' is required.',
        MAX: ' maximum number must be {{max}}.',
        MIN: ' minimum number must be {{min}}.',
        MAX_LENGTH: ' can\'t be more than {{max_length}} characters.',
        MIN_LENGTH: ' can\'t be less than {{min_length}} characters.',
        PATTERN: ' is invalid format.',
        MIN_SELECTION: 'Atleast {{min_selection}} option must be checked',
        MAX_SELECTON: 'Maximum {{max_selection}} option can be checked',
        REQ_SELECTON: ' is required.',
        CONFIRM_PASSWORD: ' does not match.',
        HOLIDAY_FROM_DATE: 'Holiday Start Date Must be less than Holiday End Date',
        HOLIDAY_TO_DATE: 'Holiday End Date Must be  greater than Holiday Start Date',
        TO_DATE: 'To Date Must be greate than From Date',
        FROM_DATE: 'From Date Must be less than To Date',
        MULTI_EMAIL: 'Please enter valid email address',
        BREAK_GT_SHIFT_DURATION: 'Break Duration Can not be greater than Shift Duration',
        CONTACT_MOBILE_COUNTRY_CODE: 'Please Enter Both Country Code And Contact Person Mobile Number Or None',
      },
      GLOBAL_ERROR: 'Something Went Wrong Please Try Again',
      /////////////// AUTH //////////////
      LOGIN: 'Invalid Crendentials',
      REGISTER: 'Error in register or Email already exists.',
      FORGOT_PASSWORD: 'User not found.',
      RESET_TOKEN: 'Token is expired or invaliad.',
      RESET_PASSWORD: 'Error in reset password.',
      SESSION_TIMEOUT: 'Session Time Out Please Login Again',
    },
    SUCCESS: {
      /////////////// AUTH //////////////
      //// LOGIN ////
      LOGIN: 'Logged in successful',
      LOGOUT: 'Logged out successful',
      FORGOT_PASSWORD: 'User reset password link sent successfully.',
      REGISTER: 'User Registered Successfully please check your email',
      RESET_PASSWORD: 'Your password reset successfully.',
      RESET_TOKEN: 'Your token validate succsssfully.',
      //// BUSINESS ////
      CREATE_BUSINESS: 'New Business Created Successfully',
      SELECT_BUSINESS: 'Request has been sent. Business Admin will notify you through email',
      CHANGE_BUSINESS: 'Business Changed Successfully',
      //// MASTER BUSINESS ////
      PUBLIC_HOLIDAY_ADD: 'Public Holiday has been added',
      PUBLIC_HOLIDAY_UPDATE: 'Public Holiday updated successfully.',
      PUBLIC_HOLIDAY_DELETE: 'Public Holiday deleted successfully.',
      TRAINING_LICENSE_ADD: 'Training/License added successfully.',
      TRAINING_LICENSE_UPDATE: 'Training/License updated successfully.',
      TRAINING_LICENSE_DELETE: 'Training/License deleted successfully.',
      STRESS_PROFILE_ADD: 'Stress Profile added successsfully.',
      STRESS_PROFILE_UPDATE: 'Stress Profile updated successsfully.',
      STRESS_PROFILE_DELETE: 'Stress Profile deleted successsfully.',
      LEAVE_ADD: 'Leave added successfully.',
      LEAVE_UPDATE: 'Leave updated successfully.',
      LEAVE_DELETE: 'Leave deleted successfully.',
      PENDING_BUSINESS_USER_APPROVE: 'User Reqest approved successfully',
      PENDING_BUSINESS_USER_REJECT: 'User Reqest rejected successfully',
      //// BUSINESS SETTING////
      BUSINESS_SETTING: 'Business Setting Updated SuccessFully',
      // EMPLOYEE
      CREATE_EMPLOYEE: 'Employee Created Successfully',
      UPDATE_EMPLOYEE: 'Employee Updated Successfully',
      DELETE_EMPLOYEE: 'Employee Deleted Successfully',
      ACTIVE_EMPLOYEE: 'Employee Activated Successfully',
      CREATE_EMPLOYEE_ADDRESS: 'Employee Address Created Successfully',
      UPDATE_EMPLOYEE_ADDRESS: 'Employee Address Updated Successfully',
      CREATE_EMPLOYEE_CONTACT: 'Employee Contact Created Successfully',
      UPDATE_EMPLOYEE_CONTACT: 'Employee Contact Updated Successfully',
      UPDATE_EMPLOYEE_PAY_RATES: 'Employee Pay Rates Updated Successfully',
      UPDATE_EMPLOYEE_JOB_INFORMATION: 'Employee Job Information Updated Successfully',
      UPDATE_EMPLOYEE_BANK_DETAILS: 'Employee Bank Details Updated Successfully',
      CREATE_EMPLOYEE_ASSIGN_LOCATION: 'Employee Assign Location Added Successfully',
      UPDATE_EMPLOYEE_ASSIGN_LOCATION: 'Employee Assign Location Updated Successfully',
      CREATE_EMPLOYEE_TRAINING_LICENSE: 'Employee/Training License Created Successfully',
      UPDATE_EMPLOYEE_TRAINING_LICENSE: 'Employee/Training License Updated Successfully',
      DELETE_EMPLOYEE_TRAINING_LICENSE: 'Employee/Training License Deleted Successfully',
      CREATE_EMPLOYEE_UNAVAIBILITY: 'Employee Unavability Added Successfully',
      UPDATE_EMPLOYEE_UNAVAIBILITY: 'Employee Unavability Updated Successfully',
      DELETE_EMPLOYEE_UNAVAIBILITY: 'Employee Unavability Deleted Successfully',
      CREATE_EMPLOYEE_LEAVE: 'Employee Leave Added Successfully',
      UPDATE_EMPLOYEE_LEAVE: 'Employee Leave Updated Successfully',
      DELETE_EMPLOYEE_LEAVE: 'Employee Leave Deleted Successfully',
      // client
      DELETE_CLIENT: 'Client Deleted Successfully',
      CREATE_CLIENT: 'New Client Created Successfully',
      UPDATE_CLIENT: 'Client Updated SuccessFully',
      INVITE_CLIENT: 'Client invitation sent successfully',
      CLIENT_LOCATION: 'Client Location Added SuccessFully',
      DELETE_CLIENT_LOCATION: 'Location Deleted Successfully',
      UPDATE_CLIENT_LOCATION_SCHEDULING: 'Location Scheduling Updated Successfully',
      UPDATE_CLIENT_LOCATION_TIMESHEET: 'Location Timesheet Updated Successfully',
      // Task
      TASK_GROUP_ADD: 'Task Group Added Successfully',
      TASK_GROUP_PERSONAL_ADD: 'Task Group Personal Added Successfully',
      TASK_GROUP_UPDATE: 'Task Group Updated Successfully',
      TASK_GROUP_PERSONAL_UPDATE: 'Task Group Personal Updated Successfully',
      TASK_GROUP_DELETE: 'Task Group Deleted Successfully',
      TASK_GROUP_PERSONAL_DELETE: 'Task Group Personal Deleted Successfully',
      TASK_GROUP_CHILD_DELETE: 'Task Group Child Deleted Successfully',
      UPDATE_CLIENT_REWARD: 'Client Reward Updated SuccessFully',
      UPDATE_CLIENT_SETTING: 'Client Setting Updated SuccessFully',
      UPDATE_CLIENT_CONTACT: 'Client Contact Updated SuccessFully',
      UPDATE_CLIENT_ADDRESS: 'Client Address Updated SuccessFully',
      INSERT_CLIENT_CONTACT: 'Client Contact Added SuccessFully',
      INSERT_CLIENT_ADDRESS: 'Client Address Added SuccessFully',
      CLIENT_AREA: 'Client Area Added SuccessFully',
      CLIENT_AREA_UPDATE: 'Client Area Update SuccessFully',
      CLIENT_AREA_DELETE: 'Client Area Deleted SuccessFully',
      SUCCESS_LOCATION_UPDATE: 'Client Location Updated SuccessFully',
      // USER
      USER_CONTACT: 'User Contact Updated SuccessFully',
      USER_ADDRESS: 'User Address Updated SuccessFully',

      //QR CODE
      INSERT_QR_CODE: 'New QR Code generated SuccessFully',
      // BUSINESS ROLE
      INSERT_BUSINESS_ROLE: 'Business Role Inserted SuccessFully',
      UPDATE_BUSINESS_ROLE: 'Business Role Updated SuccessFully',
      // NEWS FEED
      NEWS_FEED_ADD: 'Post Added Successfully',
      NEWS_FEED_STATUS: 'News Feed Status Updated SuccessFully',
      NEWS_FEED_DELETE: 'Post Deleted Successfully',
      NEWS_FEED_COMMENT_DELETE: 'Comment Deleted Successfully',
      // lOOP
      INSERT_LOOP: 'Loop Inserted SuccessFully',
      UPDATE_LOOP: 'Loop Updated SuccessFully',
      DELETE_LOOP: 'Loop Deleted SuccessFully',

      // Dashboard
      INSERT_DASHBOARD: 'Dashboard Inserted SuccessFully',
      UPDATE_DASHBOARD: 'Dashboard Details Updated SuccessFully',
      DELETE_DASHBOARD: 'Dashboard Deleted SuccessFully',

      // Dashboard Widget
      INSERT_DASHBOARD_WIDGET: 'Dashboard Widget Inserted SuccessFully',
      UPDATE_DASHBOARD_WIDGET: 'Dashboard Widget Updated SuccessFully',
      DELETE_DASHBOARD_WIDGET: 'Dashboard Widget Deleted SuccessFully',
      // leave request
      LEAVE_APPROVE: 'Leave Approved Successfully',
      LEAVE_REJECT: 'Leave Rejected Successfully',
    },
    BUTTON: {
      LOGIN_BUTTON: 'Sign In',
      SUBMIT_BUTTON: 'Submit',
      SIGNUP_BUTTON: 'Sign Up',
      FORGOT_PASSWORD_BUTTON: 'Forgot Password',
      BACK_BUTTON: 'Back',
      CANCEL_BUTTON: 'Cancel',
      CLOSE_BUTTON: 'Close',
      RESET_PASSWORD_BUTTON: 'Reset Password',
      NEXT: 'Next',
      PREVIOUS: 'Previous',
      NEXT_STEP: 'Next Step',
      CHANGE_PLAN: 'Change Plan',
      SELECT_BUSINESS: 'Select Business',
      CREATE_NEW_BUSINESS: 'Create Business',
      BUSINESS: 'Business',
      ADD: 'Add New',
      SAVE_BUTTON: 'Save',
      SEND_BUTTON: 'Send',
      UPDATE_BUTTON: 'Update',
      PUBLIC_HOLIDAY: 'Add Public Holiday',
      TRAINING_LICENSE: 'Add Training/License',
      STRESS_PROFILE: 'Add Stress Profile',
      SEND_INVITE: 'Send Invite',
      LEAVE_BUTTON: 'Add Leave',
      APPROVE: 'Approve',
      REJECT: 'Reject',
      SAVE_ADD_MORE: 'Save \& Add More',
      VIEW: 'View',
      DELETE_ALL: 'Delete All',
      UPDATE_STATUS: 'Update Status',
      TASK_GROUP_PERSONAL: 'Add Personal Task',
      SAVE_CLIENT: 'Save Client',
      SAVE_CONTACT: 'Save Contact',
      SAVE_ADDRESS: 'Save Address',
      SAVE_SETTING: 'Save Setting',
      SAVE_REWARD: 'Save Reward',
      SAVE_LOCATION: 'Save Location',
      SAVE_SCHEDULING: 'Save Scheduling',
      SAVE_TIMESHEET: 'Save Timesheet',
      APPROVE_SELECTED: 'Approve Selected',
      REJECT_SELECTED: 'Reject Selected',
      BUSINESS_ROLE: 'Business Role',
      TASK_GROUP_LOCATION: 'Add Task Group Location',
      TASK_GROUP_AREA: 'Add Task Group Area',
      PERSONAL_DETAIL: 'Save Personal Detail',
      PAY_RATE: 'Save Pay Rate',
      JOB_INFORMATION: 'Save Job Information',
      BANKING_DETAIL: 'Save Banking Detail',
      ASSIGN_LOCATION: 'Save Assign Location',
      UNAVAILABILITY: 'Save Unavailability',
      PRINT: 'Print',
      QR_CODE: 'Generate New QR Code',
    },
    LINK: {
      NO_ACCOUNT: 'Don\'t have an account yet?',
      ALREADY_HAVE_AN_ACCOUNT: 'Already Have an account?',
    },
    LABEL: {
      OR: 'Or',
      BACK_TO: 'Back to',
    },
    TABLE_COLUMNS: {
      // PUBLIC HOLIDAY COLUMNS
      PUBLIC_HOLIDAY_NAME: 'Public Holiday Name',
      PUBLIC_HOLIDAY_START_DATE: 'Start Date',
      PUBLIC_HOLIDAY_END_DATE: 'End Date',
      PUBLIC_HOLIDAY_EXPORT_CODE: 'Export Code',
      // STRESS PROFILE TABLE COLUMNS
      STRESS_PROFILE_NAME: 'Stress Profile Name',
      STRESS_PROFILE_MAX_HOURS_DAY: 'Max Hours Per Day',
      STRESS_PROFILE_MAX_DAYS_WEEK: 'Max Days Per Week',
      STRESS_PROFILE_MAX_HOURS_SHIFT: 'Max Hours Per Shift',
      STRESS_PROFILE_MIN_HOURS_OVERNIGHT: 'Min Hours Bet. Overnight',
      STRESS_PROFILE_MAX_HOURS_WEEK: 'Max Hours Per Week',
      // TRAININGLICENSE TABLE COLUMNS
      TRAINING_LICENSE_NAME: 'Training/License Name',
      // LEAVE TABLE COLUMNS
      LEAVE_NAME: 'Leave Name',
      LEAVE_TYPE: 'Leave Type',
      LEAVE_EXPORT_CODE: 'Export Code',
      // PENDING USER TABLE COLUMNS
      USER_FIRST_NAME: 'First Name',
      USER_LAST_NAME: 'Last Name',
      USER_EMAIL_ADDRESS: 'Email Address',
      USER_REQUESTED_ON: 'Requested On',
      // TASK GROUP PERSONAL TABLE COLUMNS
      TASK_NAME: 'Task Name',
      FROM_DATE: 'From Date',
      TO_DATE: 'To Date',
      EMPLOYEE_NAME: 'Employee Name',
      COMPLETED_DATE: 'Completed Date',
      // TASK GROUP TABLE COLUMNS
      TASK_GROUP_NAME: 'Task Group Name',
      TASK_GROUP_INDIVIDUAL_GRUOP: 'INDIVIAUL/GROUP',
      TASK_GROUP_FROM_TIME: 'From Time',
      TASK_GROUP_TO_TIME: 'To Time',
      TASK_GROUP_TYPE: 'Task Gruop Type',
      TASK_GROUP_SUB_TASK_COUNT: 'Sub Task Count',
      // CLIENT
      AREA_NAME: 'Area Name',
      AREA_ADDRESS: 'Area Address',
      AREA_SEND_GPS: 'Area Send GPS',
      AREA_REMARK: 'Area Remark',
      CLIENT_NAME: 'Client Name',
      CONTACT_PERSON_NAME: 'Contact Person Name',
      CONTACT_PERSON_EMAIL: 'Contact Person Email',
      COUNTRY: 'Country',
      STATE: 'State',
      CITY: 'City',
      ENABLE_LOGIN: 'Enable Login',
      SEND_INVITE: 'Send Invite',
      LOCATION_NAME: 'Location Name',
      ADDRESS: 'Address',
      WEEKS_START_WITH: 'Weeks Start With',
      LOCATION_OPEN_TIME: 'Location Open Time',
      LOCATION_COUNT: 'Location Count',
      EMPLOYEE_COUNT: 'Employee Count',
      // BUSINESS ROLE
      BUSINESS_ROLE_NAME: 'Role Name',
      BUSINESS_ROLE_ASSOCIATE: 'Role Associate',
      IS_OWNER: 'Is Owner',
      AREA_LOCATION: 'Location',
      AREA_COUNT: 'Area Count',
      USER_ROLE: 'User Role',
      NOTES: 'Note',
    },
  },
};
